import { callApiToServer } from "../callApi";

export async function purchaseCredit(authtoken, purchaseObject, programId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      amount: purchaseObject.amount,
      category_id: purchaseObject.category_id,
      charity_program_id: programId,
    });

    let endUrl = "v1/auth/distribute-program-amount";
    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
